module.exports = __webpack_public_path__ + "static/media/City of Utrecht.225453bb.png";